import { render, staticRenderFns } from "./ReportSubscriptions.vue?vue&type=template&id=66940316&"
import script from "./ReportSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ReportSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports